/// <amd-module name="typeahead/features/OnePlusRecentHistoryParamModifier" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [{
    tabs: ["hotel"],
}];

const USER_HISTORY: string = "USERHISTORY";

export class OnePlusRecentHistoryParamModifier implements IRequestUrlParamModifier {
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
    JQueryPromise<ISuggestServiceQueryParams> {
        let deferred: JQueryDeferred<ISuggestServiceQueryParams> = $.Deferred();
        if (typeof params !== "undefined") {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((shouldExecute) => {
                    if (shouldExecute) {
                        params.categories = USER_HISTORY;
                    }
                })
                .always(() => {
                    deferred.resolve(params);
                });
        } else {
            deferred.resolve(params);
        }
        return deferred.promise();
    }
}
